import { Loader2, LockKeyhole } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/Dialog';

interface CheckoutRedirectDialogProps {
  open: boolean;
}

export function CheckoutRedirectDialog({ open }: CheckoutRedirectDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        data-testid="checkout-redirect-dialog"
        showCloseButton={false}
        overlayClassName="bg-black/40"
        className="w-[calc(100%-2rem)] max-w-[400px] gap-0 rounded-xl p-8 text-center sm:min-h-[328px] sm:p-10 max-sm:bottom-0 max-sm:top-auto max-sm:translate-y-0 max-sm:w-full max-sm:max-w-none max-sm:rounded-b-none max-sm:rounded-t-2xl"
      >
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl border border-primary/20 bg-primary/10 text-primary">
          <LockKeyhole className="h-9 w-9" aria-hidden="true" />
        </div>
        <DialogTitle className="text-lg sm:text-xl">Preparing secure checkout</DialogTitle>
        <DialogDescription className="mt-2 text-base">Redirecting to Stripe Checkout</DialogDescription>
        <Loader2 className="mx-auto mt-7 h-10 w-10 animate-spin text-primary" aria-label="Loading checkout" />
        <p className="mt-5 text-sm text-muted-foreground">This will only take a moment...</p>
      </DialogContent>
    </Dialog>
  );
}
